import { chakra, Flex, Text } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { ReactNode } from "react";
import VipInfoBg from "@/assets/images/space/vip-info-bg.png";

interface VipInfoProps {
  title: string | ReactNode;
  btnText: string | ReactNode;
  info: string | ReactNode;
  onBtnClick(): void;
}
const goldGradient = `linear-gradient(90deg, #F0BF68, #F9E5AE);`;

function VipInfoCardPro(props: VipInfoProps) {
  const { title, btnText, info, onBtnClick, ...other } = props;
  return (
    <Flex
      className="vip-info-card"
      h="60px"
      flexGrow={1}
      w="100%"
      color="white"
      userSelect="none"
      align="center"
      rounded="4px"
      p="10px 14px"
      bg={`url(${VipInfoBg})`}
      bgSize="cover"
      {...other}
    >
      <Flex h="100%" flexDir="column" flexGrow={1} justify="center">
        <Text fontSize="14px" fontWeight="600" bg={goldGradient} bgClip="text">
          {title}
        </Text>
        <Text color="#e4c797" fontSize="12px" transform="scale(0.83)" transformOrigin="left">
          {info}
        </Text>
      </Flex>
      <Flex
        alignItems="center"
        justifyContent="center"
        w="50px"
        h="25px"
        fontSize="16px"
        rounded="full"
        fontWeight="600"
        pos="relative"
        cursor="pointer"
        onClick={onBtnClick}
        _before={{
          content: '""',
          position: "absolute",
          left: 0,
          top: 0,
          w: "100%",
          h: "100%",
          bg: "linear-gradient(270deg, #F0BF68 26.79%, #F9E5AE 132.14%)",
          rounded: "999px",
        }}
        _after={{
          content: '""',
          position: "absolute",
          left: 0,
          top: 0,
          w: "100%",
          h: "100%",
          bg: "#0a0a0a",
          border: "1px solid transparent",
          bgClip: "content-box",
          rounded: "999px",
        }}
      >
        <Text
          pos="relative"
          bg="linear-gradient(270deg, #F0BF68 26.79%, #F9E5AE 132.14%)"
          bgClip="text"
          fontSize="12px"
          zIndex={1}
        >
          {btnText}
        </Text>
      </Flex>
    </Flex>
  );
}

export default observer(chakra(VipInfoCardPro));
